import { NotifyHelper } from 'classes/helpers/notify.helper';
import { WebSocketHelper } from 'classes/helpers/web-socket.helper';
import { MiscHelper } from 'lib_ts/classes/misc.helper';
import { WsMsgType } from 'lib_ts/enums/machine-msg.enum';
import { useEffect } from 'react';
import slugify from 'slugify';
import { useAuthStore } from 'stores/use-auth-store';

const useCustomResponseListener = () => {
  const wsConnected = useAuthStore((s) => s.wsConnected);

  useEffect(() => {
    if (!wsConnected) {
      // not ready
      return;
    }

    const callback = (event: CustomEvent) => {
      NotifyHelper.success({
        message_md: `Received custom response from machine!`,
        buttons: [
          {
            label: 'Save Response',
            onClick: () => {
              const filename = `custom-response_${slugify(
                new Date().toISOString(),
                { strict: true }
              )}`;

              MiscHelper.saveAs(
                new Blob([JSON.stringify(event, null, 2)]),
                `${filename}.json`
              );
            },
          },
        ],
      });
    };

    WebSocketHelper.on(WsMsgType.Misc_CustomResponse, callback);

    return () => {
      WebSocketHelper.remove(WsMsgType.Misc_CustomResponse, callback);
    };
  }, [wsConnected]);
};

export default useCustomResponseListener;
